import {
    UPDATEGATEWAYACCOUNT_SUCCESS,
    UPDATEGATEWAYACCOUNT_FAILED,
    RESET_UPDATEGATEWAYACCOUNT,
    LOADING_UPDATEGATEWAYACCOUNT,
    NETWORK_ERROR_UPDATEGATEWAYACCOUNT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateGatewayAccount = () => {
    return { type: RESET_UPDATEGATEWAYACCOUNT };
};

const updateGatewayAccount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEGATEWAYACCOUNT });
    await partnerServices
        .post("updateGatewayAccount", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateGatewayAccountsuccess(res.data));
                    break;
                default:
                    dispatch(updateGatewayAccountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_UPDATEGATEWAYACCOUNT,
                payload: err
            });
        });
};
function updateGatewayAccountsuccess(data) {
    return {
        type: UPDATEGATEWAYACCOUNT_SUCCESS,
        payload: data
    };
}
function updateGatewayAccountFailed(data) {
    return {
        type: UPDATEGATEWAYACCOUNT_FAILED,
        payload: data
    };
}

export { resetUpdateGatewayAccount, updateGatewayAccount };
